import $ from 'jquery/src/jquery';
//export const BASE_PATH = "http://localhost/dev/apis/";
//export const EL_PATH = "http://localhost/dev/e-learn-server-dev/server/";
export const BASE_PATH = "https://apis.ansatzpunkt.at/";
export const EL_PATH = "https://apis.ansatzpunkt.at/e-learn/server/";
export const COOKIE_KEY = "4wevns1k";
export const COOKIE_DOMAIN = ".apis.ansatzpunkt.at";
//export const COOKIE_DOMAIN = "localhost";

export const jquery = $;



// WEBPACK FOOTER //
// ./src/Globals.js